<div class="dialog-container">
  <div class="dialog-header flex_sb">
    <div class="dialog-header-title clr-333 lh-130 fw-600">
      {{ 'ORDER_DASHBOARD.COMPLETE_ORDER' | fallbackTranslate | titlecase }}
    </div>
    <div class="dialog-header-cross" (click)="cancelClicked()">
      <img [src]="images.CROSS" class="img-20" alt="close" />
    </div>
  </div>

  <div class="dialog-form">
    <div class="confirm-class">
      <p class="m-0 alert-text clr-333 lh-130 fw-600">
        {{
          'ORDER_DASHBOARD.ARE_YOU_SURE_CUSTOMER_HAS_RECEIVED_THIS_DELIVERY_ORDER'
            | fallbackTranslate
        }}
      </p>
      <div *ngIf="errorMsg" class="error-field">
        <p
          id="delivery-error-text"
          class="m-0 fw-400 lh-130 error-text"
        >
          *{{ errorMsg }}
        </p>
      </div>
    </div>

    <div class="btn-container flex_sb">
      <button
        nz-button
        class="footer-btn fw-600 lh-140 wd-100 cancel-btn"
        (click)="cancelClicked()"
      >
        {{ 'ORDER_DASHBOARD.NO_LET_ME_CHECK' | fallbackTranslate }}
      </button>
      <button
        nz-button
        [ngClass]="{'color-white disable-action': errorMsg}"
        [nzLoading]="isLoading"
        class="footer-btn fw-600 lh-140 save-btn wd-100"
        (click)="completeOrder()"
      >
        {{ 'ORDER_DASHBOARD.YES_COMPLETE_THE_ORDER' | fallbackTranslate }}
      </button>
    </div>
  </div>
</div>
